import { CommunityButton, People } from "./Buttons";

import Avatar1 from "../assets/avatar-2.png";
import Avatar2 from "../assets/avatar-1.png";
import Radium from "radium";
import United from "../assets/united-blue.svg";
import brokoliDemo from "../assets/brokoli-demo-community.svg";
import certified from "../assets/community-certified.svg";
import facebook from "../assets/facebook.svg";
import instagram from "../assets/instagram.svg";
import linkedin from "../assets/linkedin.svg";
import logoWhite from "../assets/opis-white.svg";
import { useParams } from "react-router-dom";
import web from "../assets/web.svg";

const CommunityDetail = ({ name, images, links, description }) => {
  const { id } = useParams();

  return (
    <div style={styles.card}>
      <section style={styles.card.firstSection}>
        <div style={styles.card.firstSection.imgContainer}>
          <img src={logoWhite} alt="opis" />
          <CommunityButton text="+Unirse" styles={styles.card.firstSection.imgContainer.btn} />
        </div>
        <h1 style={styles.card.firstSection.h1}>Actuar para Ganar</h1>
        <p style={styles.card.firstSection.p}>Entra en este mundo regenerativo.</p>
        <p style={styles.card.firstSection.p}>¡Descubre desafíos y NFTs con proposito!</p>

        <section style={styles.card.firstSection.secondContainer}>
          <div style={styles.card.firstSection.secondContainer.links}>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <img src={web} alt="web" />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <img src={linkedin} alt="linkedin" />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <img src={facebook} alt="facebook" />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <img src={instagram} alt="instagram" />
            </a>
          </div>
          <div style={styles.card.firstSection.secondContainer.more}>
            <People circleSize={18} imgOne={Avatar1} imgTwo={Avatar2} textThree="+10" />
            <div style={styles.card.firstSection.secondContainer.more.challenges}>
              <img src={United} alt="desafios" />
              <p style={styles.card.firstSection.secondContainer.more.challenges.p}>2 desafíos</p>
            </div>
          </div>
        </section>
      </section>

      <section style={styles.card.secondSection}>
        <div style={styles.card.secondSection.container}>
          <img src={brokoliDemo} alt={name} style={styles.card.secondSection.container.img} />
          <div style={styles.card.secondSection.container.certified}>
            <p style={styles.card.secondSection.container.certified.p}>
              OPIS <span style={styles.card.secondSection.container.certified.p.span}>génesis</span>
            </p>
            <section style={styles.card.secondSection.container.certified.section}>
              <p style={styles.card.secondSection.container.certified.section.p}>#00</p>
              <img src={certified} alt="certified" />
            </section>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Radium(CommunityDetail);

const query = {
  xs: "@media (max-width: 576px)",
  sm: "@media (max-width: 767px)",
  md: "@media (max-width: 992px)",
  lg: "@media (max-width: 1200px)",
  xl: "@media (max-width: 1600px)",
  small: "@media (max-width: 600px)",
  medium: "@media (max-width: 1440px)",
  large: "@media (max-width: 1700px)",
};

const styles = {
  card: {
    backgroundColor: "#78D504",
    margin: "0 8px 48px 8px",
    padding: "50px",
    borderRadius: "20px",
    color: "white",
    display: "grid",
    gridTemplateColumns: "1.5fr 1fr",
    gridGap: "16px",
    maxWidth: "1050px",
    [query.xs]: { gridTemplateColumns: "1fr", padding: "16px" },
    firstSection: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      [query.xs]: { alignItems: "center" },
      imgContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        gridGap: "16px",
        btn: { marginBottom: "10px", backgroundColor: "#2B3674" },
      },
      h1: {
        color: "white",
        fontSize: "30px",
        fontWeight: 800,
        margin: "8px 0 8px 0",
        textAlign: "start",
        [query.xs]: { margin: 0, textAlign: "center" },
      },
      p: { margin: 0, fontSize: "16px", textAlign: "start", [query.xs]: { textAlign: "center" } },
      secondContainer: {
        display: "flex",
        justifyContent: "space-between",
        maxWidth: "315px",
        width: "100%",
        marginTop: "20px",
        [query.sm]: { justifyContent: "center", gridGap: "24px" },
        links: { display: "flex", gridGap: "32px", [query.sm]: { gridGap: "24px" } },
        more: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          challenges: {
            display: "flex",
            alignItems: "center",
            marginTop: "8px",
            p: { margin: "0 0 0 8px", color: "#2B3674", fontWeight: 500 },
          },
        },
      },
    },
    secondSection: {
      display: "flex",
      alignItems: "center",
      [query.xs]: { justifyContent: "center" },
      container: {
        position: "relative",
        height: "fit-content",
        img: { maxWidth: "100%", border: "2px solid white", borderRadius: "25px" },
        certified: {
          padding: "8px 16px",
          position: "absolute",
          bottom: 0,
          right: 0,
          backgroundColor: "rgba(179, 179, 179, 0.5)",
          borderRadius: "20px",
          backdropFilter: "blur(1px)",
          p: { fontWeight: 900, fontSize: "16px", margin: 0, span: { fontWeight: 400 } },
          section: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: { margin: 0, fontSize: "16px", fontWeight: 800 },
          },
        },
      },
    },
  },
};
